"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductList = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _InfiniteScroll = require("../InfiniteScroll");
var _ProductCard = require("../ProductCard");
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _something_wrong = _interopRequireDefault(require("../../assets/images/something_wrong.png"));
var _order_none = _interopRequireDefault(require("../../assets/images/order_none.png"));
var _searchEmpty = _interopRequireDefault(require("../../assets/images/search-empty.svg"));
var _Loader = require("../Loader");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
var _elementScrollTrack = require("../../utils/tracking/elementScrollTrack");
var _useTracking = require("../../hooks/useTracking");
var _ProductCardNew = require("../ProductCardNew");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ProductList = function ProductList(props) {
  var _previewMockData$$pre;
  var onLoadMore = props.onLoadMore,
    type = props.type,
    selectOrderText = props.selectOrderText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 5 : _props$limit,
    itemText = props.itemText,
    itemsText = props.itemsText,
    userType = props.userType,
    showOrderId = props.showOrderId,
    onButtonClick = props.onButtonClick,
    showLoading = props.showLoading,
    componentTrackingData = props.componentTrackingData,
    _props$previewMockDat = props.previewMockData,
    previewMockData = _props$previewMockDat === void 0 ? {} : _props$previewMockDat,
    formatOrderListItem = props.formatOrderListItem,
    _props$statusText = props.statusText,
    statusText = _props$statusText === void 0 ? {} : _props$statusText,
    isUIOptimisation = props.isUIOptimisation,
    productOrOrderEmptyText = props.productOrOrderEmptyText,
    noMoreText = props.noMoreText;
  var previewOtherOrderList = (_previewMockData$$pre = previewMockData === null || previewMockData === void 0 ? void 0 : previewMockData.$preview_other_order_list) !== null && _previewMockData$$pre !== void 0 ? _previewMockData$$pre : [];
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    listData = _useState2[0],
    setListData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isError = _useState6[0],
    setIsError = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    startIndex = _useState8[0],
    setStartIndex = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    hasMore = _useState10[0],
    setHasMore = _useState10[1];
  var containerRef = (0, _react.useRef)(null);
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var elementScrollTrack = new _elementScrollTrack.ElementScrollTrackManage();
  var panelOrderScrollTracking = result.panelOrderScroll;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('product-list');
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var orderScrollTrackHandler = function orderScrollTrackHandler() {
    console.log('触发滚动上报', panelOrderScrollTracking === null || panelOrderScrollTracking === void 0 ? void 0 : panelOrderScrollTracking.trackingScroll, panelOrderScrollTracking);
    if (panelOrderScrollTracking !== null && panelOrderScrollTracking !== void 0 && panelOrderScrollTracking.trackingScroll) {
      tracker.scroll(panelOrderScrollTracking.trackingScroll);
    }
  };
  var addScrollTrackEvent = function addScrollTrackEvent() {
    if (containerRef.current) {
      elementScrollTrack.addTrack(containerRef.current, _elementScrollTrack.ScrollType.Vertical, {
        scrollCallback: orderScrollTrackHandler,
        containerElement: containerRef.current
      });
    }
  };
  function reset() {
    setStartIndex(0);
    setHasMore(true);
    setLoading(false);
    setIsError(false);
    setListData([]);
  }
  (0, _react.useEffect)(function () {
    loadMoreCb();
    return function () {
      reset();
    };
  }, []);
  (0, _react.useEffect)(function () {
    addScrollTrackEvent();
    return function () {
      elementScrollTrack.removeAllTrack();
    };
  }, [panelOrderScrollTracking, containerRef.current]);
  var loadMoreCb = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _listData, res, data;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(disabled || !hasMore || loading)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(previewOtherOrderList !== null && previewOtherOrderList !== void 0 && previewOtherOrderList.length)) {
                _context.next = 9;
                break;
              }
              _listData = previewOtherOrderList.filter(function (x) {
                return x.order_list_type === type;
              }).map(function (x) {
                return formatOrderListItem ? formatOrderListItem(x, statusText) : x;
              });
              if (!(_listData !== null && _listData !== void 0 && _listData.length)) {
                _context.next = 9;
                break;
              }
              setListData(_listData);
              setLoading(false);
              setHasMore(false);
              return _context.abrupt("return");
            case 9:
              // 设置状态为正在加载
              setLoading(true);
              _context.prev = 10;
              _context.next = 13;
              return onLoadMore({
                page_num: startIndex,
                page_size: limit,
                status: type,
                user_type: userType
              });
            case 13:
              res = _context.sent;
              data = res.data;
              if (data) {
                // 如果列表为空，则认为加载完成，同时设置加载状态为加载完
                if (data.length === 0) {
                  setHasMore(false);
                  setLoading(false);
                } else {
                  // 分页并设置单次加载完成
                  setStartIndex(startIndex + 1);
                  setListData(listData.concat(data));
                  setLoading(false);
                  setHasMore(true);
                }
              } else {
                setLoading(false);
                setIsError(true);
                setHasMore(false);
              }
              _context.next = 23;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](10);
              setLoading(false);
              setIsError(true);
              console.error(_context.t0);
            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 18]]);
    }));
    return function loadMoreCb() {
      return _ref.apply(this, arguments);
    };
  }();
  var orderWrong = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__img")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _something_wrong.default,
    alt: "wrong"
  }), /*#__PURE__*/_react.default.createElement("p", null, trans(_constants.ORDER_STH_WENT_WRONG_TEXT))));
  var orderEmpty = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__img")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _order_none.default,
    alt: "empty"
  }), /*#__PURE__*/_react.default.createElement("p", null, trans(_constants.NO_ORDERS_YET_TEXT)));
  var orderLoading = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--loading")
  }, /*#__PURE__*/_react.default.createElement(_Loader.ListLoader, null));
  var productOrOrderEmpty = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--tipSelectContainer")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _searchEmpty.default,
    alt: "search",
    className: "".concat(prefixCls, "--tipSearchIcon")
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--tipSelectText")
  }, productOrOrderEmptyText));
  var noMoreTextContainer = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--noMoreContainer")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--noMoreText")
  }, noMoreText));
  return listData.length > 0 ? /*#__PURE__*/_react.default.createElement(_InfiniteScroll.InfiniteScroll, {
    ref: containerRef,
    showLoading: showLoading,
    style: {
      height: '100%'
    },
    onLoadMore: loadMoreCb,
    className: ["".concat(prefixCls, "-infinite-scroll"), isUIOptimisation && "".concat(prefixCls, "-infinite-scroll-white")].join(' ')
  }, listData.map(function (item) {
    return isUIOptimisation ? /*#__PURE__*/_react.default.createElement(_ProductCardNew.ProductCardNew, (0, _extends2.default)({}, item, {
      key: item.orderId,
      selectOrderText: selectOrderText,
      itemText: itemText,
      itemsText: itemsText,
      showOrderId: showOrderId
    })) : /*#__PURE__*/_react.default.createElement(_ProductCard.ProductCard, (0, _extends2.default)({}, item, {
      key: item.orderId,
      selectOrderText: selectOrderText,
      itemText: itemText,
      itemsText: itemsText,
      showOrderId: showOrderId,
      onButtonClick: onButtonClick,
      userType: userType,
      componentTrackingData: componentTrackingData
    }));
  }), isUIOptimisation && noMoreTextContainer) : loading ? orderLoading : isError ? orderWrong : isUIOptimisation ? productOrOrderEmpty : orderEmpty;
};
exports.ProductList = ProductList;